<template lang="pug">
.row-container
  .col-container.project__container
    img(src="~assets/images/svg/project/project_header_mb.svg").project__header-mobile

    h1.project__title
      | Расскажите
      br
      | о&nbsp;
      span.project__title_color своем проекте
      br
      | и мы свяжемся с вами
      br
      | в ближайшее время
    Form(:value="form" @submitted="isFormSubmitted=true" v-if="!isFormSubmitted").project__form
    template(v-else)
      h1.project__submitted-title
        | Спасибо
        br
        | за обращение!
      p.project__submitted-subtitle
        | Мы свяжемся с вами
        br
        | в ближайшее время
    img(src="~assets/images/svg/project/project_notebook.svg").project__notebook
    p.project__subtitle
      | Вдумчиво. Дорого. На совесть.
      br
      a(href="tel:+7 (800) 200 38 01").project__subtitle_link +7 800 200 38 01
      br
      a(href="mailto:order@nekidaem.ru").project__subtitle_link order@nekidaem.ru
      br
      | © 2010-{{ dt }}
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useProjectStore } from "~~/stores/project"

const isFormSubmitted = ref(false)
const dt = new Date().getFullYear()

const projectStore = useProjectStore()
await projectStore.setProjectPage()
const {title, form, meta, og} = storeToRefs(projectStore)

usePageHeadMeta(meta.value.title, meta.value.description, og.value)
</script>

<style lang="scss" scoped>
.project {

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (min-width: $breakpoint-xlarge) {
      display: block;
    }

    @media screen and (min-width: $breakpoint-xlarge) and (max-width: $breakpoint-xlarge-max) and (max-height: 800px) {
      margin-top: -50px;
      transform: scale(0.9);
    }

    @include l-desktop {
      margin-top: -150px;
    }
  }

  &__header-mobile {
    margin-top: -160px;
    margin-left: -10px;
    margin-bottom: 50px;

    @media (min-width: $breakpoint-xlarge) {
      display: none;
    }
  }

  &__title {
    font-weight: bold;
    text-transform: uppercase;
    color: $primary;
    margin-bottom: 40px;

    &_color {
      color: $gray;
    }

    @media (min-width: $breakpoint-xlarge) {
      margin-bottom: 45px;
    }

    @include l-desktop {
      font-size: 28px;
    }

    @include xl-desktop {
      font-size: 34px;
    }
  }

  &__graph,
  &__notebook {
    position: absolute;
    display: none;

    @media (min-width: $breakpoint-xlarge) {
      display: block;
    }
  }

  &__graph {
    top: 155px;
    left: 235px;
  }

  &__notebook {
    width: 80%;
    z-index: 0;

    @include l-desktop {
      top: 110px;
      left: 225px;
    }

    @include xl-desktop {
      top: 80px;
      left: 225px;
    }
  }

  &__form {
    max-width: 335px;
    margin-bottom: 57px;
    position: relative;
    z-index: 2;
  }

  &__subtitle {
    color: $primary;
    font-weight: bold;
    text-align: left;
    margin-bottom: 120px;
    max-width: 335px;
    width: 100%;

    &_link {
      color: $primary;
      text-decoration: none;
    }

    @media (min-width: $breakpoint-xlarge) {
      display: none;
    }
  }

  &__submitted-title {
    color: $primary;
    margin-bottom: 25px;

    @media (min-width: $breakpoint-xlarge) {
      margin-top: 220px;
    }
  }

  &__submitted-subtitle {
    color: $primary;
  }
}
</style>
